import { AppConfig, envConfig, isServer } from '@headless-workspace/config';
import { HeadersName } from '../config';

export const CSRF_PROTECTION_HEADER_VALUE = '1';

const MAX_AGE_SECONDS = -1; // Unspecified max-age
const CACHE_CONTROL_HEADER_VALUE = `max-age=${MAX_AGE_SECONDS}`;

export const getDefaultHeaders = () => {
    const defaultHeaders: Record<string, string> = {
        'Content-Type': 'application/json',
        'x-consumer-id': AppConfig.consumerId,
        [HeadersName.CsrfProtection]: CSRF_PROTECTION_HEADER_VALUE,
        [HeadersName.CacheControl]: CACHE_CONTROL_HEADER_VALUE,
        [HeadersName.Pragma]: CACHE_CONTROL_HEADER_VALUE,
    };

    if (envConfig.estoreConsumerVersion) {
        defaultHeaders['x-consumer-version'] = envConfig.estoreConsumerVersion;
    }

    if (isServer()) {
        defaultHeaders[HeadersName.UserAgent] = AppConfig.userAgent;
    }

    return defaultHeaders;
};

export const DEFAULT_STATUS_CODE = 500;

export enum ContentType {
    JSON = 'application/json',
    XML = 'application/xml',
}

export enum ContentFile {
    JSON = 'json',
    XML = 'xml',
}
